import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisV2ApiService } from 'src/services/contentAnalysisV2Api'

// The stored weekly insight. It does not follow the date picker (it is
// regenerated once a week), so only the analyses and the category key it.
export const useGetContentAnalysisCategoryInsightQuery = (
  analysisIds: string[] | undefined,
  category: string | null
) =>
  useQuery({
    enabled: !!category,
    queryFn: () =>
      ContentAnalysisV2ApiService.getCategoryInsight(
        { analysisIds },
        category as string
      ),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_CATEGORY_INSIGHT,
      category,
      analysisIds?.join(','),
    ],
  })
